import React, { useMemo, useState } from 'react';
import type { Office } from '../types';
import OfficeBadge from '../shared/office_badge';
import CompanyOfficeSelect from '../shared/company_office_select';

type OfficeSelectorProps = {
  enable: boolean;
  officesById: { [key: number]: Office };
  initialSelectedOfficeIds?: number[];
}
const OfficeSelector = ({ enable, officesById, initialSelectedOfficeIds = [] }: OfficeSelectorProps) => {
  if (!enable) return <ClearOfficesInput />;

  const [officeIds, setOfficeIds] = useState<Array<number>>(initialSelectedOfficeIds || []);

  const handleOfficeSelect = ({ value }) => {
    return setOfficeIds([...officeIds, parseInt(value)]);
  };

  const officeOptions : Array<{ value: string; label: string }> = useMemo(() => {
    return Object.keys(officesById).map(officeId => ({
      value: officeId,
      label: officesById[officeId].name,
    })).filter(option => !officeIds.includes(parseInt(option.value)));
  }, [officesById, officeIds]);

  const renderFormFields = useMemo(() => (
    <ul hidden={true}>
      {Object.values(officesById).map(office => (
        <li key={office.id}>
          <label>
            <input
              checked={officeIds.includes(office.id)}
              name="user[permissions_other_office_ids][]"
              type="checkbox"
              value={office.id}
            />
            {office.name}
          </label>
        </li>
      ))}
    </ul>
  ), [officesById, officeIds]);
    
  return (
    <div>
      <h5 className="mt-4 mb-3">Offices User Can Manage</h5>
      <div className="mb-3 d-flex gap-2 flex-wrap justify-content-between">
        {officeIds.map(officeId => (
          <OfficeBadge
            key={officeId}
            officeName={officesById[officeId].name}
            onClick={() => setOfficeIds(officeIds.filter(id => id !== officeId))}
          />
        ))}
        <div className="flex-grow-1">
          <CompanyOfficeSelect
            companyOfficeOptions={officeOptions}
            maxWidth={200}
            placeholder=""
            onChange={handleOfficeSelect}
          />
        </div>
      </div>
      {renderFormFields}
    </div>
  );
};

export const ClearOfficesInput = () => (
  <div className="hidden">
    <input
      name="user[clear_permissions_other_office_ids]"
      type="hidden"
      value="1"
    />
  </div>
);

export default OfficeSelector;
